<template>
    <div style="max-height: 520px" class="overflow-y-auto">
        <template v-for="(contact, index) in contacts">
            <div :key="index" class="d-flex">
                <contact-view :contact="contact" :exclude="[]" :color="color">
                </contact-view>
                <v-spacer></v-spacer>
                <psi-action-drop-down
                    :btn-class="`ma-3 ${color}`"
                    heading="Contact Actions Menu"
                    :subheading="contact.name"
                    :items="items"
                    @action="itemClicked"
                ></psi-action-drop-down>
            </div>
            <v-divider :key="`divider-${index}`"></v-divider>
        </template>
    </div>
</template>
<script>
export default {
    name: "rental-widget-contacts",
    components: {
        ContactView: () => import("../Contact/ContactView"),
    },
    props: {
        contacts: {
            type: Array,
            required: true,
        },
        color: {
            type: String,
            required: false,
            default: "primary",
        },
    },
    data() {
        return {
            items: this.$config("screen.contactActionsMenuOptions"),
        };
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    updated() {},
    detroyed() {},
    methods: {
        itemClicked(item) {
            console.log(item);
        },
    },
};
</script>

<style scoped>
</style>